import React, { useEffect, useState } from "react";
import { EXP } from "../../data";
import ExpRow from "../folio/ExpRow";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";

function WorkExperienceContainer({isNavigating}) {
  const [openIndex, setOpenIndex] = useState(-1);
  const [isTouch, setIsTouch] = useState(false);
  const {cursor} = useCursor()

  useEffect(() => {
    const mq = window.matchMedia("(hover: none)");

    setIsTouch(mq.matches);

    const handleChange = () => {
      setIsTouch(mq.matches);
    };

    mq.addEventListener("change", handleChange);

    return () => {
      mq.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <section 
    {...cursor({...CURSORS.default,background:"#fff",blendMode:'difference',size:20})}
    className="w-full bg-black">
      <div className="relative w-full bg-black">
        {EXP.map((item, index) => (
          <div
            key={item.title}
            className={index !== 0 ? "-mt-8 sm:-mt-12 md:-mt-16 lg:-mt-20" : ""}
            style={{
              position: "relative",
              zIndex: EXP.length - index,
            }}
          >
            <ExpRow
              item={item}
              index={index}
              isOpen={openIndex === index}
              open={() => setOpenIndex(index)}
              close={() =>
                setOpenIndex((value) => (value === index ? -1 : value))
              }
              isTouch={isTouch}
              isNavigating={isNavigating}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default WorkExperienceContainer;